import React from 'react';
import emailjs from 'emailjs-com';
import styled from 'styled-components';

const emailRegex = RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);

const FormLayout = styled.form`
    width: 100%;
    display: grid;
    grid-gap: 2rem;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr 3fr 1fr;
    padding: 2rem 10rem 4rem;
    font-family: "Raleway", sans-serif;
    height: 80vh;

    button {
        width: 100px;
        height: 30px;
        padding: 0.3rem;
    }

    input {
        border: none;
        background-color: white;
        box-shadow: 2px 3px 10px rgba(172,172,172,0.16);
        min-height: 48px;
    }

    @media (max-width: 1080px) {
        grid-template-columns: 1fr;
        grid-template-rows: 1fr 1fr 1fr 3fr 0.5fr;
        grid-gap: 0.7rem;

        input {
            font-size: 1.8rem;
        }
        textarea {
            font-size: 1.8rem;
        }
    }

    @media (max-width: 750px) {
        padding: 0;
        grid-template-rows: 0.7fr 0.7fr 0.7fr 3fr 0.7fr;
    }

`;

const FormWrapper = styled.section`
    padding: 3rem 10rem;
    width: 100vw;
    overflow: hidden;
    height: auto;
    background-color: #F6F6F6;
    color: #424242;
    font-size: 1.4rem;

    h2 {
        text-align: center;
    }

    button {
        background-color: #EBE044;
        border: none;
        font-weight: 500;
        text-transform: lowercase;
        box-shadow: 2px 3px 10px rgba(0,0,0,0.16);
        transition: 0.3s ease-in-out;
        &:hover {
            transform: scale(1.05);
        }
    }

    @media (max-width: 750px) {
        padding: 1rem 5rem 2rem;
    }
`;

const FormFieldWrapper = styled.div`
    display: flex;
    flex-direction: column;
    

    label {
        position: relative;
        margin-bottom: 0.4rem;
        span {
            position: absolute;
            right: 1rem;
            top: 0;
            color: red;
        } 
    }

    input {
        display: block;
        position: relative;
        height: 3.6rem;
    }
`;

const FormFieldMessage = styled.div`
    grid-column-start: 1;
    grid-column-end: 3;
    display: flex;
    flex-direction: column;

    label {
        position: relative;
        margin-bottom: 0.4rem;
        span {
            position: absolute;
            right: 1rem;
            top: 0;
            color: red;
        } 
    }

    textarea {
        height: 100%;
        border: none;
        box-shadow: 2px 3px 10px rgba(172,172,172,0.16);
    }

    @media (max-width: 1080px) {
        grid-column-end: 2;
        
    }

    @media (max-width: 750px) {

    }
`;

const InfoField = styled.p`
color: green;
`;
const ErrorField = styled.p`
color: red;
`;

class Form extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            name: null,
            email: null,
            topic: null,
            message: null,
            info: " ",
            formErrors: {
                name: "",
                email: "",
                topic: "",
                message: ""
            }
        }
    };
    errorState = (formErrorsTotal) => {
        const {name, email, topic, message} = this.state.formErrors;
        if (name.length < 1 && email.length < 1 && topic.length < 1 && message.length < 1) {
            formErrorsTotal = false;
        }

        else formErrorsTotal = true;
    }
    handleSubmit = (e) => {
        e.preventDefault();
        let formErrorsTotal = true;

        if ((this.formValid(this.state))) {
            this.setState({info: "Dziękujemy za wiadomość. Niebawem się z Państwem skontaktujemy!"})
            this.sendEmail(e);
        }

        else {
            this.setState({info: ""})
        }
    };

    formValid = ({formErrors, ...rest}) => {
        let valid = true;

        Object.values(formErrors).forEach(val => {
            val.length > 5 && (valid = false);
        });

        Object.values(rest).forEach(val => {
            val === null && (valid = false)
        })



        return valid
    }
    handleChange = (e) => {
        e.preventDefault();
        const {name, value} = e.target;
        let formErrors = this.state.formErrors;

        switch (name) {
            case 'name': 
                formErrors.name = value.length < 6  
                ? "minimalnie 6 znaków wymagane"
                : "";
                break
            case 'email': 
                formErrors.email = emailRegex.test(value) && value.length > 6 
                ? ""
                : "wymagany adres email";
                break
            case 'topic': 
                formErrors.topic = value.length < 6 
                ? "minimalnie 6 znaków wymagane"
                : "";
                break
            case 'message': 
                formErrors.message = value.length < 6  
                ? "minimalnie 6 znaków wymagane"
                : "";
                break
            default: break
            
        }

        this.setState({formErrors, [name]: value})

    }

    sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('main_email', 'main_template', e.target, 'user_am5VVDBwQNuqpJ2x3x21T')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
          e.target.reset()
    };

    render() {
        const {formErrors} = this.state;
        const fieldMessageText = this.state.info;
    return (
        <FormWrapper id="kontakt">
            <h2>Skontaktuj sie z nami</h2>
                <FormLayout onSubmit={this.handleSubmit}>
                    <FormFieldWrapper>
                        <label htmlFor="name">Imie i nazwisko {formErrors.name.length > 0 && (<span>{formErrors.name}</span>)}</label>
                        <input 
                        type="text" 
                        name="name"
                        id="name"
                        onChange={this.handleChange}
                        noValidate
                        />            
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <label htmlFor="email">Email {formErrors.email.length > 0 && (<span>{formErrors.email}</span>)}</label>
                        <input 
                        type="email" 
                        name="email" 
                        id="email"
                        onChange={this.handleChange}
                        noValidate
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <label htmlFor="topic">Temat {formErrors.topic.length > 0 && (<span>{formErrors.topic}</span>)}</label>    
                        <input 
                        type="topic" 
                        name="topic" 
                        id="topic"
                        onChange={this.handleChange}
                        noValidate
                        />
                    </FormFieldWrapper>
                    <FormFieldMessage>
                        <label htmlFor="message">Message {formErrors.message.length > 0 && (<span>{formErrors.message}</span>)}</label>
                        <textarea 
                        name="message"
                        id="message" 
                        onChange={this.handleChange}
                        noValidate
                    />
                    </FormFieldMessage>
                    <button type="submit" value="Send">Prześlij</button>
                    {fieldMessageText.length > 0 ? (<InfoField>{fieldMessageText}</InfoField>) : (<ErrorField>Prosimy o prawidłowe wypełnienie wszystkich pól. Dziękujemy!</ErrorField>)}
                </FormLayout>
        </FormWrapper>
    )
    }
};

export default Form